export const getColumnWidth = (field, isReviewSwitchHidden) => {
  const base = field.subfield_column_width_in_rem * 16
  const extra = isReviewSwitchHidden(field) ? 0 : 80
  return base + extra
}
